import OCRStreamComponent from "@/components/ocr_component/OCRComponent.vue";
import { MAIN_CONTROLLER } from "@/utils/main_controller.js";
import { PREPOPULATE_INPUT } from "@/utils/prepopulate_input.js";

import BreadCrumb from "@/components/BreadCrumb/BreadCrumb.vue";
import ClientLogo from "@/components/ClientLogo/ClientLogo.vue";
import { API_BASE_URL } from "@/config";
import { validateToken } from "@/utils/auth";


export default {
  name: "OcrVerification",
  mixins: [MAIN_CONTROLLER, PREPOPULATE_INPUT],
  components: {
    BreadCrumb,
    ClientLogo,
    OCRStreamComponent,
  },
  data() {
    return {
      ocrConfig: {
        showDebugPanel: true,
        scenario: "FullAuth",
        multipageProcessing: true,
        multipageMaxPages: 2,
      },
      first_name: '',
      last_name: '',
      submitting_data: false,
    };
  },

  computed: {
    workflow_id() {
      return this.$store.getters.get_workflow_id;
    },
  },

  methods: {
    handleDocumentProcessed(data) {
      this.submitting_data = true;
      // Store document list for API call
      if (data.documentList) {
        var document_list = data.documentList;
        this.document_verification(document_list);
      }
      else if (data.transactionId) {
        var transaction_id = data.transactionId;
        this.document_reader_server_side(transaction_id);
      }
    },
    handleScanStarted() {
      // Scroll to top with smooth animation
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      
      // Also scroll document elements smoothly
      document.documentElement.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      
      // Use setTimeout to ensure DOM is ready, then hide overflow
      setTimeout(() => {
        // Find and hide overflow on the container-fluid
        const containers = document.querySelectorAll('.container-fluid');
        containers.forEach(container => {
          container.style.overflow = 'hidden';
          container.scrollTop = 0;
        });
        
        // Hide on body and html
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
      }, 600); // Wait for smooth scroll to complete
    },
    document_reader_server_side(transaction_id) {
      const TOKEN = localStorage.getItem("token");
      const SAFPS_URL = `${API_BASE_URL}/verify_api/personnel_verification/document_reader_server_side/`;
      const DATA = {
        transaction_id: transaction_id,
        workflow_id: this.workflow_id,
        on_behalf_application: this.$route.name === 'behalf_application' ? true : false,
      };
      $.ajax({
        url: SAFPS_URL,
        method: "POST",
        contentType: "application/json",
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        data: JSON.stringify(DATA),
        beforeSend: () => {
          Swal.fire({
            text: "Processing Document",
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
        },
        success: (response) => {
          Swal.close();
          const status_message = response.status;

          if (status_message === "success") {
            this.completeService();
          } else if (status_message === "error") {
            Swal.fire({
              icon: "error",
              text: "Could not read document, please provide a valid document and try again",
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.reload();
              }
            });
          } else {
            Swal.fire({
              icon: "error",
              text: "Our service is currently unavailable. Please try again later",
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.reload();
              }
            });
          }
        },
        error: (error) => {
          Swal.close();
          let error_message = "Error retrieving data";

          if (error.responseJSON) {
            error_message = error.responseJSON.id_number[0];
            Swal.fire({
              icon: "error",
              text: error_message,
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.reload();
              }
            });
          } else {
            Swal.fire({
              icon: "error",
              text: error_message,
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.reload();
              }
            });
          }
        },
      });
    },
    document_verification(document_list) {

      const TOKEN = localStorage.getItem("token");
      const SAFPS_URL = `${API_BASE_URL}/verify_api/personnel_verification/document_reader/`;
      const DATA = {
        document_list: document_list,
        workflow_id: this.workflow_id,
        firstnames: this.first_name,
        lastname: this.last_name,
        on_behalf_application: this.$route.name === 'behalf_application' ? true : false,
      };

      $.ajax({
        url: SAFPS_URL,
        method: "POST",
        contentType: "application/json",
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        data: JSON.stringify(DATA),
        beforeSend: () => {
          Swal.fire({
            text: "Processing Document",
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
        },
        success: (response) => {
          Swal.close();
          const status_message = response.status;

          if (status_message === "success") {
            this.completeService();
          } else if (status_message === "error") {
            Swal.fire({
              icon: "error",
              text: "Could not read document, please provide a valid document and try again",
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.reload();
              }
            });
          } else {
            Swal.fire({
              icon: "error",
              text: "Our service is currently unavailable. Please try again later",
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.reload();
              }
            });
          }
        },
        error: () => {
          Swal.fire({
            icon: "error",
            text: "An error occurred while processing your request.",
          });
        },
      });
    },
  },

  mounted() {
    if (!validateToken(this.$router)) return;
    this.get_customer_data();
  },
};
